<div class="custom-dropdown-bottom">
  <mat-nav-list disableRipple>
    <a mat-list-item *ngIf="model.user.portal != 'merchant'" class="item-wrap" (click)="changeItem()"
      [routerLink]="['/', model.partner, model.account, 'settings', 'profile']">
      <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-between center">
        <span class="item">{{'menu.user.userSettings' | translate}}</span>
        <span class="complement fs-14 fc-9">{{ model.user.attributes.locale ? model.user.attributes.locale[0] :
          'pt-br'}}</span>
      </div>
    </a>
    <a mat-list-item *ngIf="model.user.portal == 'merchant'" class="item-wrap" (click)="changeItem()"
      [routerLink]="['/', model.partner, model.account, model.user.merchantKey, 'settings', 'profile']">
      <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-between center">
        <span class="item">{{'menu.user.userSettings' | translate}}</span>
        <span class="complement fs-14 fc-9">{{ model.user.attributes.locale ? model.user.attributes.locale[0] :
          'pt-br'}}</span>
      </div>
    </a>
    <a mat-list-item
      *ngIf="(model.user.isAdmin || model.user.isViewerOwner)  && !(model.user.portal == 'merchant') && !(model.user.isSales || model.user.isSupportMerchant)"
      class="item" (click)="changeItem()" [routerLink]="['/', model.partner, model.account, 'settings', 'company']">
      {{'menu.user.companySettings' | translate}}
    </a>
    <a mat-list-item
      *ngIf="(model.user.isAdmin || model.user.isTiSpecialist) && !(model.user.portal == 'merchant')  && !(model.user.isSales || model.user.isSupportMerchant)"
      class="item" (click)="changeItem()" [routerLink]="['/', model.partner, model.account, 'settings', 'developer']">
      {{'menu.user.developer' | translate}}
    </a>
    <a mat-list-item
      *ngIf="model.user.isAdmin && !(model.user.portal == 'merchant') && !(model.user.isSales || model.user.isSupportMerchant)"
      class="item" (click)="changeItem()" [routerLink]="['/', model.partner, model.account, 'settings', 'users']">
      {{'menu.user.users' | translate}}
    </a>
    <a mat-list-item
      *ngIf="model.user.isAdmin && model.user.portal == 'merchant'  && !(model.user.isSales || model.user.isSupportMerchant)"
      class="item" (click)="changeItem()"
      [routerLink]="['/', model.partner, model.account, model.user.merchantKey, 'settings', 'merchant']">
      {{'menu.user.merchant' | translate}}
    </a>
    <a mat-list-item
      *ngIf="(model.user.isAdmin || model.user.isTiSpecialist) && !(model.user.portal == 'merchant') && !(model.user.isSales || model.user.isSupportMerchant)"
      class="item" [routerLink]="['/', model.partner, model.account, 'settings', 'webhooks']" (click)="changeItem()">
      Webhooks
    </a>
    <!-- <a mat-list-item class="item" [routerLink]="['/', model.partner, model.account, 'settings', 'help']" (click)="logout()">{{'menu.user.help-center' | translate}}</a> -->
    <a mat-list-item class="item"
      [routerLink]="['/', model.partner, model.account, 'settings', 'help']">{{'menu.user.help-center' | translate}}</a>

    <a mat-list-item class="item" (click)="logout()">{{'menu.user.logout' | translate}}</a>
  </mat-nav-list>
</div>
